// @generated by protoc-gen-connect-es v1.6.1
// @generated from file omnios/v1/eval.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { AddEvalDatasetRowsRequest, AddEvalDatasetRowsResponse, CompareEvalRunsRequest, CreateEvalDatasetRequest, DeleteEvalDatasetRequest, DeleteEvalDatasetRowsRequest, EvalDataset, EvalDatasetRow, EvalRun, EvalRunComparison, FreezeEvalDatasetRequest, GenerateSyntheticDatasetRequest, GenerateSyntheticDatasetResponse, GetEvalDatasetRequest, GetEvalRunRequest, ImportEvalDatasetRequest, ImportEvalDatasetResponse, ListEvalDatasetRowsRequest, ListEvalDatasetRowsResponse, ListEvalDatasetsRequest, ListEvalDatasetsResponse, ListEvalRunRowsRequest, ListEvalRunRowsResponse, ListEvalRunsRequest, ListEvalRunsResponse, NewVersionEvalDatasetRequest, StartEvalRunRequest, UpdateEvalDatasetRowRequest } from "./eval_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service omnios.v1.EvalService
 */
export const EvalService = {
  typeName: "omnios.v1.EvalService",
  methods: {
    /**
     * Dataset CRUD
     *
     * @generated from rpc omnios.v1.EvalService.CreateEvalDataset
     */
    createEvalDataset: {
      name: "CreateEvalDataset",
      I: CreateEvalDatasetRequest,
      O: EvalDataset,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.EvalService.GetEvalDataset
     */
    getEvalDataset: {
      name: "GetEvalDataset",
      I: GetEvalDatasetRequest,
      O: EvalDataset,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.EvalService.ListEvalDatasets
     */
    listEvalDatasets: {
      name: "ListEvalDatasets",
      I: ListEvalDatasetsRequest,
      O: ListEvalDatasetsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.EvalService.FreezeEvalDataset
     */
    freezeEvalDataset: {
      name: "FreezeEvalDataset",
      I: FreezeEvalDatasetRequest,
      O: EvalDataset,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.EvalService.NewVersionEvalDataset
     */
    newVersionEvalDataset: {
      name: "NewVersionEvalDataset",
      I: NewVersionEvalDatasetRequest,
      O: EvalDataset,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.EvalService.DeleteEvalDataset
     */
    deleteEvalDataset: {
      name: "DeleteEvalDataset",
      I: DeleteEvalDatasetRequest,
      O: EvalDataset,
      kind: MethodKind.Unary,
    },
    /**
     * Dataset rows
     *
     * @generated from rpc omnios.v1.EvalService.AddEvalDatasetRows
     */
    addEvalDatasetRows: {
      name: "AddEvalDatasetRows",
      I: AddEvalDatasetRowsRequest,
      O: AddEvalDatasetRowsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.EvalService.ImportEvalDataset
     */
    importEvalDataset: {
      name: "ImportEvalDataset",
      I: ImportEvalDatasetRequest,
      O: ImportEvalDatasetResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.EvalService.ListEvalDatasetRows
     */
    listEvalDatasetRows: {
      name: "ListEvalDatasetRows",
      I: ListEvalDatasetRowsRequest,
      O: ListEvalDatasetRowsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.EvalService.UpdateEvalDatasetRow
     */
    updateEvalDatasetRow: {
      name: "UpdateEvalDatasetRow",
      I: UpdateEvalDatasetRowRequest,
      O: EvalDatasetRow,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.EvalService.DeleteEvalDatasetRows
     */
    deleteEvalDatasetRows: {
      name: "DeleteEvalDatasetRows",
      I: DeleteEvalDatasetRowsRequest,
      O: EvalDataset,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.EvalService.GenerateSyntheticDataset
     */
    generateSyntheticDataset: {
      name: "GenerateSyntheticDataset",
      I: GenerateSyntheticDatasetRequest,
      O: GenerateSyntheticDatasetResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Eval runs
     *
     * @generated from rpc omnios.v1.EvalService.StartEvalRun
     */
    startEvalRun: {
      name: "StartEvalRun",
      I: StartEvalRunRequest,
      O: EvalRun,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.EvalService.GetEvalRun
     */
    getEvalRun: {
      name: "GetEvalRun",
      I: GetEvalRunRequest,
      O: EvalRun,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.EvalService.ListEvalRuns
     */
    listEvalRuns: {
      name: "ListEvalRuns",
      I: ListEvalRunsRequest,
      O: ListEvalRunsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.EvalService.ListEvalRunRows
     */
    listEvalRunRows: {
      name: "ListEvalRunRows",
      I: ListEvalRunRowsRequest,
      O: ListEvalRunRowsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.EvalService.CompareEvalRuns
     */
    compareEvalRuns: {
      name: "CompareEvalRuns",
      I: CompareEvalRunsRequest,
      O: EvalRunComparison,
      kind: MethodKind.Unary,
    },
  }
};

